import { cn } from '@lair-finance/util'
import { DisconnectButton } from '@/domains/header/ui/WalletModal/DisconnecctButton.tsx'
import { CloseButton } from '@/domains/header/ui/WalletModal/CloseButton.tsx'
import { forwardRef } from 'react'
import { WalletAsset } from '@/domains/header/ui/WalletModal/WalletAsset'

export const WalletModal = forwardRef<HTMLDivElement, { className?: string }>(({ className }, ref) => {
  return (
    <div
      className={cn(
        'relative inline-flex flex-col w-screen md:w-[478px] bg-greyscale-600 p-[19px] md:p-[23px] border border-greyscale-500 md:rounded-[16px] shadow-[0_0_12px_0_rgba(30,31,35,.50)] overflow-x-hidden overflow-y-auto invisible-scrollbar',
        className,
      )}
      ref={ref}
    >
      <CloseButton className={'max-md:hidden absolute top-[15px] sm:top-[19px] right-3 sm:right-[15px]'} />

      <p className={'max-md:hidden mb-6 typo-heading-1 text-greyscale-100'}>Your Wallet</p>
      <WalletAsset className={'mb-5 lg:mb-6'} />
      <DisconnectButton />
    </div>
  )
})
WalletModal.displayName = 'WalletModal'
